<template>
  <bb-error-page
    :title="translations.title"
    :description="translations.description"
  />
</template>

<script>

export default {
  name: 'credit-card-action-done',
  computed: {
    translations () {
      return {
        title: this.$pgettext('credit_card_modal', 'Action successful'),
        description: this.$pgettext('credit_card_modal', 'To return to app please close this window')
      }
    }
  }
}
</script>
